// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__l8cmW","tab":"ProcedureTabs_tab__1ozpa"};